import React, { useMemo } from 'react';
import { Stack } from '@mui/material';
import { BillType, TAKEAWAY_STATUS } from '../../all-types';
import { TakeawayCard } from './components/TakeawayCard';
import { KanbanColumn } from './components/KanbanColumn';

interface TakeawayOrdersDisplayProps {
  takeawayBills: BillType[];
  setTakeawayBills: React.Dispatch<React.SetStateAction<BillType[]>>;
}

const BOARD_HEIGHT = 'calc(100vh - 180px)';

const TakeawayOrdersDisplay: React.FC<TakeawayOrdersDisplayProps> = ({
  takeawayBills,
  setTakeawayBills,
}) => {
  const pending = useMemo(
    () => takeawayBills.filter((b) => b.takeAwayStatus === 'PENDING'),
    [takeawayBills]
  );
  const ready = useMemo(
    () => takeawayBills.filter((b) => b.takeAwayStatus === 'READY'),
    [takeawayBills]
  );

  const handleStatusChange = (id: string, newStatus: TAKEAWAY_STATUS | 'DONE') => {
    setTakeawayBills((prev) =>
      prev.map((b) => (b._id && b._id === id ? { ...b, takeAwayStatus: newStatus as any } : b))
    );
  };

  return (
    <Stack direction="row" spacing={2} sx={{ height: BOARD_HEIGHT }}>
      <KanbanColumn title="Pending" count={pending.length} height={BOARD_HEIGHT}>
        {pending.map((order) => (
          <TakeawayCard
            key={order?._id || order.billNo}
            order={order}
            onStatusChange={handleStatusChange}
          />
        ))}
      </KanbanColumn>

      <KanbanColumn title="Ready" count={ready.length} height={BOARD_HEIGHT}>
        {ready.map((order) => (
          <TakeawayCard
            key={order?._id || order.billNo}
            order={order}
            onStatusChange={handleStatusChange}
          />
        ))}
      </KanbanColumn>
    </Stack>
  );
};

export { TakeawayOrdersDisplay };
